/**
 * Billing plan constants and feature access control.
 * Must stay in sync with backend BillingPlan enum in models.py.
 */

export const PLANS = {
  LIGHT: 'light',
  STANDARD: 'standard',
  PREMIUM: 'premium',
};

export const PLAN_LABELS = {
  [PLANS.LIGHT]: 'ライト',
  [PLANS.STANDARD]: 'スタンダード',
  [PLANS.PREMIUM]: 'プレミアム',
};

/**
 * Badge tone (components/ui Badge) per plan. Premium is emphasis, not a
 * warning, so it gets info; standard gets primary; light stays muted.
 */
export const PLAN_TONES = {
  [PLANS.LIGHT]: 'muted',
  [PLANS.STANDARD]: 'primary',
  [PLANS.PREMIUM]: 'info',
};

/**
 * Plan hierarchy for comparison (higher = more features).
 */
const PLAN_LEVEL = {
  [PLANS.LIGHT]: 0,
  [PLANS.STANDARD]: 1,
  [PLANS.PREMIUM]: 2,
};

/**
 * Features that require Standard plan or above.
 */
const STANDARD_FEATURES = new Set([
  'ng',              // NG管理
  'commute-groups',  // 帰宅グループ管理
  'usage-fee',       // 利用料金
  'usage-history',   // 利用履歴
]);

/**
 * Check if a given plan has access to a specific feature.
 * @param {string} plan - The billing plan (light, standard, premium)
 * @param {string} featureId - The feature/tab identifier
 * @returns {boolean}
 */
export function hasFeatureAccess(plan, featureId) {
  if (!plan) return false;
  if (STANDARD_FEATURES.has(featureId)) {
    return (PLAN_LEVEL[plan] ?? -1) >= PLAN_LEVEL[PLANS.STANDARD];
  }
  return true;
}

/**
 * Check if the plan meets a minimum required plan level.
 * @param {string} currentPlan
 * @param {string} requiredPlan
 * @returns {boolean}
 */
export function meetsMinimumPlan(currentPlan, requiredPlan) {
  return (PLAN_LEVEL[currentPlan] ?? -1) >= (PLAN_LEVEL[requiredPlan] ?? 0);
}
